module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card card-box"
  }, [(_vm.menu_tab_inner_view['general_goods_category_products']) ? _c('div', {
    staticClass: "card"
  }, [_c('h3', [_c('span', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  })])]), _vm._v(_vm._s(_vm.general_goods_category.category_name))]), _vm._v(" "), _vm._l((_vm.general_goods_category_products), function(set_product, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(set_product.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("₦‎" + _vm._s(set_product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('p', [_c('button', {
      staticClass: "btn sp-button-02-lt",
      on: {
        "click": function($event) {
          _vm.product = set_product;
          _vm.add_general_products = 1;
          _vm.addProduct();
        }
      }
    }, [_vm._v("SELECT")])])])])])
  })], 2) : (_vm.menu_tab_inner_view['custom_add']) ? _c('div', {
    staticClass: "card"
  }, [_vm._v("\r\n          Custom Add New\r\n        ")]) : _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-right": "1em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("General Products  ")]), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "padding-left": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('custom_add')
      }
    }
  }, [_vm._v("Your Product")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('h4', [_vm._v("select from these categories")]), _vm._v(" "), ((Object.keys(_vm.general_goods).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, _vm._l((_vm.general_goods), function(category, index) {
    return _c('div', {
      staticClass: "card card-row"
    }, [_c('p', [_c('a', {
      staticClass: "card",
      on: {
        "click": function($event) {
          _vm.setGeneralGoodsCategoryProducts(category)
        }
      }
    }, [_vm._v(_vm._s(category.category_name))])])])
  })) : _vm._e()])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c131b648"}!./src/pages/Manage/AddItems/template.html
// module id = 626
// module chunks = 0